import { render, staticRenderFns } from "./sensor_ctl_attr.vue?vue&type=template&id=35110c4c&"
import script from "./sensor_ctl_attr.vue?vue&type=script&lang=js&"
export * from "./sensor_ctl_attr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports